(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ring-size-indicator"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.js-ring-size-indicator').forEach((root) => {
    const trigger = root.querySelector('.ring-size-indicator__trigger');
    if (!trigger) return;

    const setOpen = (open) => {
      root.classList.toggle('is-open', open);
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      setOpen(!root.classList.contains('is-open'));
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
